import { faXmark } from '@awesome.me/kit-eee5f32034/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Markdown } from '@onwardtravelsolutions/package-react/Components';
import { NoticeType } from '@onwardtravelsolutions/package-react/Enums';
import { Notice } from '@onwardtravelsolutions/package-react/Types';
import ProgressBar from '../ProgressBar';

type ToastNoticeProps = {
    notice: Notice;
    className?: string;
    closeToast: () => void;
    isPaused: boolean;
};

export default function ToastNotice({
    closeToast,
    notice,
    isPaused,
    className = '',
}: ToastNoticeProps) {
    className += ' sm:rounded overflow-hidden w-full';

    switch (notice.type) {
        case NoticeType.Information:
            className += ' bg-success';
            break;
        case NoticeType.Warning:
        case NoticeType.Error:
        default:
            className += ' bg-error';
            break;
    }

    return (
        <div className={className} data-testid='toast-notice'>
            <div className='flex flex-row justify-between shadow-lg p-3 w-full text-white'>
                <div>
                    {notice && (
                        <h3 className='font-bold'>{notice.title}</h3>
                    )}
                    <Markdown content={notice.body} className='text-sm' />
                </div>
                <div className='shrink-0'>
                    <button
                        onClick={() => {
                            closeToast();
                        }}
                        className='hover:opacity-70 transition cursor-pointer'
                    >
                        <FontAwesomeIcon icon={faXmark} fontSize={16} />
                    </button>
                </div>
            </div>
            {notice.ttl && (
                <ProgressBar
                    duration={notice.ttl}
                    ascending={false}
                    paused={isPaused}
                    onComplete={closeToast}
                />
            )}
        </div>
    );
}
